import classNames from 'classnames';
import React from 'react';
import {ProgressStepComponentProps} from './ProgressStepComponent';

interface ProgressStepLayourProps extends ProgressStepComponentProps {
  isClickable?: boolean;
  isCompleted: boolean;
  isSplit?: boolean;
}

export const ProgressStepLayout: React.FC<ProgressStepLayourProps> = ({
  selected,
  disabled,
  inProgress,
  onClick,
  style,
  isClickable,
  isCompleted,
  className,
  isSplit,
}) => {
  return (
    <div
      className={classNames('progress-bar__step-wrapper', {
        'progress-bar__step-wrapper--selected': selected,
        'progress-bar__step-wrapper--split': isSplit,
      })}
    >
      <div
        onClick={onClick}
        style={style}
        className={classNames(
          'progress-bar__step',
          {
            'progress-bar__step--selected': selected,
            'progress-bar__step--disabled': !isClickable,
            'progress-bar__step--completed': !disabled && isCompleted,
            'progress-bar__step--in-progress': inProgress,
            'progress-bar__step--split': isSplit,
          },
          className
        )}
      />
    </div>
  );
};
